module.exports = __webpack_public_path__ + "img/map.95661edd.jpg";